import Vue from 'vue';

Vue.mixin({
  methods: {
    redirect(page, id = null) {
      if (id) {
        this.$router.push(`/${page}/${id}`);
        return;
      }

      this.$router.push(`/${page}`);
    },
    redirectNewTab(page, key = null) {
      if (key) {
        window.open(`/${page}/${key}`, '_blank');

        return;
      }

      window.open(`/${page}`, '_blank');
    }
  }
});
